import Animation from './Animation';

export default class Wait extends Animation {

	constructor (master, time, before, callback) {

		super(master, time, before, callback);
	}
}